import React from 'react';
import { Divider } from '@mui/material';
import { ScreenTitle } from 'components';
import styles from './styles.module.sass';

const FacilityItem = ({ facility }) => (
  <div key={facility.id} className={styles.item}>
    <ScreenTitle title={facility.name} subtitle={facility.website} />
    <h2>{facility.address1}</h2>
    <h2>{facility.address2}</h2>
    <h2>
      {facility.city} {facility.state}, {facility.zip}
    </h2>
    <Divider />
  </div>
);

export { FacilityItem };
